import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface InvoicePlanDetail {
  id: string;
  plan_id: string;
  plan_name: string;
  system_name: string;
  system_code: string;
  price_monthly: number;
  is_trial: boolean;
  billing_period: string;
  status: string;
}

export const useInvoicePlans = (companyId?: string) => {
  return useQuery({
    queryKey: ['invoice-plans', companyId],
    queryFn: async () => {
      if (!companyId) return [];

      const { data, error } = await supabase
        .from('company_system_plans')
        .select(`
          id,
          plan_id,
          is_trial,
          billing_period,
          status,
          plans!inner (
            id,
            name,
            price_monthly,
            systems!inner (
              id,
              name,
              code
            )
          )
        `)
        .eq('company_id', companyId)
        .eq('status', 'active');

      if (error) throw error;

      return (data || []).map(item => ({
        id: item.id,
        plan_id: item.plan_id,
        plan_name: item.plans?.name || 'Plano Desconhecido',
        system_name: item.plans?.systems?.name || 'Sistema Desconhecido',
        system_code: item.plans?.systems?.code || 'unknown',
        price_monthly: (item.plans?.price_monthly || 0),
        is_trial: item.is_trial || false,
        billing_period: item.billing_period || 'monthly',
        status: item.status
      })) as InvoicePlanDetail[];
    },
    enabled: !!companyId,
  });
};